export default "__VITE_ASSET__7bF8zy3M__"